// Language Selector Custom Element
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initLanguageSelector();
    this.initClickOutside();
  }

  initLanguageSelector() {
    const options = this.querySelectorAll('.custom-language-options a');
    const input = this.querySelector('.input');
    const form = this.querySelector('form');

    options.forEach(option => {
      option.addEventListener('click', () => {
        if (input && form) {
          input.value = option.getAttribute('data-value');
          form.submit();
        }
      });
    });
  }

  initClickOutside() {
    const opener = this.querySelector('.custom-lang-opener');

    document.addEventListener('click', (event) => {
      if (!this.contains(event.target) && opener) {
        opener.checked = false;
      }
    });
  }
}

customElements.define('localization-form', LocalizationForm);
